export const useNavigationStore = defineStore("navigation", () => {
  // States
  const redirect = ref(null);

  return {
    redirect,
  };
});
